<template>
  <NuxtLoadingIndicator />
  <DynamicDialog />
  <div class="main-container">
    <div class="admin-sidebar">
      <AdminSideBar />
      <SidebarFooter />
    </div>
    <div class="content-wrapper">
      <Header />
      <div class="admin-content">
        <slot/>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import DynamicDialog from 'primevue/dynamicdialog';
import AdminSideBar from '~/components/layout/Admin/AdminSideBar.vue';
import SidebarFooter from '~/components/layout/Admin/SidebarFooter.vue';
import Header from '~/components/layout/Admin/Header.vue';
import Footer from '~/components/layout/Admin/Footer.vue';
</script>

<style scoped lang="scss">
.main-container {
  @apply flex w-full min-h-screen bg-zinc-100 2xl:max-w-[1200px] 2xl:mx-auto;

  .admin-sidebar {
    @apply flex flex-col justify-center items-center shrink-0 border-r border-border-gray;
  }

  .content-wrapper {
    @apply flex flex-col flex-1;

    .admin-content {
      @apply flex-1 w-full;
    }
  }
}
</style>
